import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=ae23c42c&scoped=true&"
import script from "./BannerForm.vue?vue&type=script&lang=js&"
export * from "./BannerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae23c42c",
  null
  
)

export default component.exports